import { USER_ROUTE } from "../constants/route.constants";
import { encodeRouteParam } from "../utility/parseRouteParams";

export const encodeUserUrl = (_id, firstName, lastName) => {
  const f = encodeRouteParam(firstName);
  const l = encodeRouteParam(lastName);
  return `${USER_ROUTE}/${f}-${l}/${_id}`;
};



// WEBPACK FOOTER //
// ./src/helpers/userHelper.js